import React, { ReactNode } from 'react';
import { KeycloakError } from 'keycloak-js';
import type KeycloakType from 'keycloak-js';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import type { AuthClientEvent, AuthClientTokens } from '@react-keycloak/core';

import Loading from '../Loading/Loading';
import AppStorage from '../Storage/Storage';
import { keycloakInitOps, KeycloakInstanceWrapper } from './Keycloak';
import { Navigate } from 'react-router-dom';

interface KeycloakWrapperProps {
  children: React.ReactElement;
}

interface KeycloakWrapperState {
  navigateComponent?: ReactNode;
}

class KeycloakWrapper extends React.PureComponent<KeycloakWrapperProps, KeycloakWrapperState> {
  private readonly storage: AppStorage;

  constructor(props: KeycloakWrapperProps) {
    super(props);

    this.storage = AppStorage.getInstance();

    this.state = {
      navigateComponent: undefined,
    };
  }

  keyCloakEventHandler = (
    event: AuthClientEvent,
    error: KeycloakError | undefined,
  ): void => {
    if (error) throw new Error(error.error_description);

    if (event === 'onAuthLogout') {
      this.setState({
        navigateComponent: <Navigate to="/loggedout" replace={true} />,
      });
    }
  };

  tokensHandler = (tokens: AuthClientTokens): void => {
    /* In case we need it later in storage */
    if (tokens.token) {
      this.storage.setToken(tokens.token);
    }
  };

  render(): React.ReactElement {
    const { children } = this.props;
    const { navigateComponent } = this.state;

    if (navigateComponent) {
      return (<>{navigateComponent}</>);
    }

    return (
      <ReactKeycloakProvider
        authClient={KeycloakInstanceWrapper.getInstance() as unknown as KeycloakType}
        initOptions={keycloakInitOps}
        LoadingComponent={<Loading />}
        onEvent={this.keyCloakEventHandler}
        onTokens={this.tokensHandler}
      >
        { children }
      </ReactKeycloakProvider>
    );
  }
}

export default KeycloakWrapper;
